import Icon from '@/components/ui/AppIcon';

interface SecurityFeature {
  id: string;
  icon: string;
  title: string;
  description: string;
}

const securityFeatures: SecurityFeature[] = [
  {
    id: 'sec_1',
    icon: 'ShieldCheckIcon',
    title: 'ISO 27001 Zertifiziert',
    description: 'Internationale Sicherheitsstandards für Informationssicherheit.',
  },
  {
    id: 'sec_2',
    icon: 'LockClosedIcon',
    title: 'Ende-zu-Ende-Verschlüsselung',
    description: 'Alle SMS-Daten werden mit AES-256 verschlüsselt übertragen und gespeichert.',
  },
  {
    id: 'sec_3',
    icon: 'DocumentCheckIcon',
    title: 'DSGVO-konform',
    description: 'Vollständige Einhaltung der europäischen Datenschutz-Grundverordnung.',
  },
  {
    id: 'sec_4',
    icon: 'KeyIcon',
    title: '2FA für 2FA',
    description: 'Zugriff auf Ihr Dashboard erfordert selbst eine Zwei-Faktor-Authentifizierung.',
  },
  {
    id: 'sec_5',
    icon: 'ClipboardDocumentListIcon',
    title: 'Audit-Protokolle',
    description: 'Vollständige Nachverfolgung aller Zugriffe und Aktivitäten.',
  },
  {
    id: 'sec_6',
    icon: 'ServerIcon',
    title: 'Deutsche Server',
    description: 'Alle Daten werden ausschließlich in deutschen Rechenzentren gespeichert.',
  },
];

export default function SecuritySection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <div className="flex justify-center mb-4">
            <div className="bg-emerald-100 p-3 rounded-full">
              <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-emerald-600" />
            </div>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-foreground tracking-tight mb-4">
            Sicherheit an erster Stelle
          </h2>
          <p className="text-muted-foreground font-light">
            Ihre 2FA-Codes sind bei uns sicherer als auf Ihrem Smartphone
          </p>
        </div>

        {/* Security Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {securityFeatures.map((feature, index) => (
            <div
              key={feature.id}
              className={`bg-white p-8 rounded-2xl shadow-sm border border-slate-200 hover:shadow-lg hover:border-primary/20 transition-all duration-300 reveal delay-${(index + 1) * 100}`}
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center text-primary mb-6">
                <Icon name={feature.icon as any} size={24} variant="solid" className="text-primary" />
              </div>
              
              {/* Content */}
              <h3 className="font-semibold text-lg text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Compliance Badges */}
        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 reveal delay-400">
          <div className="flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-sm border border-slate-200">
            <Icon name="ShieldCheckIcon" size={20} variant="solid" className="text-emerald-600" />
            <span className="text-sm font-medium text-foreground">ISO 27001</span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-sm border border-slate-200">
            <Icon name="DocumentCheckIcon" size={20} variant="solid" className="text-blue-600" />
            <span className="text-sm font-medium text-foreground">DSGVO</span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-sm border border-slate-200">
            <Icon name="LockClosedIcon" size={20} variant="solid" className="text-primary" />
            <span className="text-sm font-medium text-foreground">AES-256</span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-sm border border-slate-200">
            <Icon name="ServerIcon" size={20} variant="solid" className="text-slate-600" />
            <span className="text-sm font-medium text-foreground">Made in Germany</span>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center reveal delay-400">
          <a
            href="#"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:text-blue-700 transition-colors"
          >
            Sicherheits-Whitepaper herunterladen
            <Icon name="ArrowDownTrayIcon" size={16} variant="outline" className="text-primary" />
          </a>
        </div>
      </div>
    </section>
  );
}